import { useState } from "react";
import { GoogleMapsProvider } from "@ubilabs/google-maps-react-hooks";
import { Space } from "antd";
import { MAP_KEY, mapOptions } from "../../../../constants/cons";
import { MapaWrapper } from "./mapa/MapaWrapper";

export const MapaUbicacion = ({ onDireccionChange, initialLatLng, whatsAppProps, mostrarTalleres }) => {
  const [mapContainer, setMapContainer] = useState();

  return (
    <GoogleMapsProvider
      libraries={["places"]}
      googleMapsAPIKey={MAP_KEY}
      mapOptions={mapOptions}
      mapContainer={mapContainer}
    >
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <MapaWrapper
          onDireccionChange={onDireccionChange}
          initialLatLng={initialLatLng}
          whatsAppProps={whatsAppProps}
          mostrarTalleres={mostrarTalleres}
        />
        <div
          className="crear-servicios-v2__mapa-container"
          ref={(node) => setMapContainer(node)}
        />
      </Space>
    </GoogleMapsProvider>
  );
};
